import { trailerCategoryUrls } from './trailerCategoryUrls';
import { getTrailerTypeBrowseImage } from './trailerTypeCategoryImages';
import {
  getNationalTrailerTypePath,
  nationalTrailerTypePages,
} from './nationalTrailerTypeLandingPages';

/**
 * Compact national trailer-type directory for /trailer-hire.
 * Furniture maps to box search (no dedicated furniture category).
 */
export const TRAILER_HIRE_PAGE_TYPE_IDS = ['cage', 'box', 'enclosed', 'car', 'furniture'];

export const getTrailerHirePageTypeCards = intl =>
  TRAILER_HIRE_PAGE_TYPE_IDS.map(id => {
    const searchId = id === 'furniture' ? 'box' : id;
    const landing = nationalTrailerTypePages[searchId];
    return {
      id,
      ...(landing
        ? { href: getNationalTrailerTypePath(landing.slug) }
        : { searchUrl: trailerCategoryUrls[searchId] }),
      title: intl.formatMessage({ id: `TrailerHirePage.trailerType.${id}` }),
      description: intl.formatMessage({ id: `TrailerHirePage.trailerTypeSummary.${id}` }),
      cta: intl.formatMessage({ id: `TrailerHirePage.trailerTypeCta.${id}` }),
      image: getTrailerTypeBrowseImage(searchId),
    };
  });

/**
 * Shared guide-card ids for location pages. Slugs come from adviceArticles —
 * other advice topics belong in FAQ answers or inline content, not cards.
 */
export const LOCATION_PAGE_GUIDE_DEFS = [
  { id: 'cost', slug: 'trailer-hire-cost-guide' },
  { id: 'boxVsCage', slug: 'box-vs-cage-trailer' },
  { id: 'towCapacity', slug: 'how-much-can-my-car-tow' },
];

const mapLocationAdviceGuides = intl =>
  LOCATION_PAGE_GUIDE_DEFS.map(({ id, slug }) => ({
    id,
    routeName: 'AdviceArticlePage',
    params: { slug },
    label: intl.formatMessage({ id: `LocationPageGuides.guide.${id}` }),
    summary: intl.formatMessage({ id: `LocationPageGuides.guideSummary.${id}` }),
  }));

/** National /trailer-hire useful guides (3 advice-hub cards). */
export const getTrailerHirePageGuideLinks = intl => mapLocationAdviceGuides(intl);

/** State landings: same 3 advice cards; Help sits in the Need help aside. */
export const getStateLandingPageGuideLinks = intl => mapLocationAdviceGuides(intl);

/** Suburb landings: same 3 advice cards. */
export const getSuburbLandingPageGuideLinks = intl => mapLocationAdviceGuides(intl);
